export const IconGrayCloseCross: {
  name: 'icon_gray_close_cross-d4d60e953e83'
} = {
  name: 'icon_gray_close_cross-d4d60e953e83'
}
